import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { DocumentTypeService, IDocumentType } from 'document-type-picker-lib';
import { MessageNotificationService } from 'message-notification-service-lib';
import { IdentityStorage } from 'storage-service-lib';

@Component({
  selector: 'app-document-type-dropdown',
  imports: [MatSelectModule, MatIconModule, ReactiveFormsModule],
  templateUrl: './document-type-dropdown.component.html',
  styleUrl: './document-type-dropdown.component.css',
})
export class DocumentTypeDropdownComponent implements OnInit, OnChanges {
  @Input() entityTypes: string[] = [];
  @Input() control: FormControl | undefined;

  documentTypes: IDocumentType[] = [];

  constructor(
    private messageNotificationService: MessageNotificationService,
    private documentTypeService: DocumentTypeService,
    private identityStorage: IdentityStorage,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.handleEntityTypesChanges(changes);
  }

  ngOnInit(): void {
    this.initDocumentTypes();
  }

  clearSelection(event?: MouseEvent) {
    event?.stopPropagation();
    this.control?.reset();
    this.control?.markAsDirty();
  }

  private initDocumentTypes() {
    const identity = this.identityStorage.get();
    if (!identity || !this.entityTypes?.length) {
      return;
    }

    this.documentTypeService.getDocumentTypes(identity.namespace, this.entityTypes).subscribe({
      next: (docTypes) => {
        this.documentTypes = docTypes.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
      },
      error: (error) => this.messageNotificationService.error(`Failed to load document types.`, error),
    });
  }

  private handleEntityTypesChanges(changes: SimpleChanges) {
    const entityTypesChange = changes['entityTypes'];
    if (entityTypesChange && !entityTypesChange.isFirstChange()) {
      this.initDocumentTypes();
      if (entityTypesChange.previousValue !== undefined) {
        this.clearSelection();
      }
    }
  }
}
